import { createSlice } from '@reduxjs/toolkit';

import type { ReduxContentState } from './types';

export const initialState: ReduxContentState = {};

export const { actions, reducer } = createSlice({
  name: 'content',
  initialState,
  reducers: {},
});
